import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createSelector } from 'reselect';
import { selectOwnCustomerKey } from 'flow/selectors/customer-selectors';
import { selectOwnExtensionKey } from 'flow/selectors/ExtensionSelectors';
import { getIsAppEmbedded } from 'flow/selectors/selectors';
import { isSlimmedTeamsApp } from 'flow/utils/app-utils';
import FavoriteContactsCentralSwitchWidget from 'flow/components/central-switch/central-switch-widgets/FavoriteContactsCentralSwitchWidget';
import FavoritePbxCentralSwitchWidget from 'flow/components/central-switch/central-switch-widgets/FavoritePbxCentralSwitchWidget';
import RecentContactedCentralSwitchWidget from 'flow/components/central-switch/central-switch-widgets/RecentContactedCentralSwitchWidget';
import UserCalendarCentralSwitchWidget from 'flow/components/central-switch/central-switch-widgets/UserCalendarCentralSwitchWidget';
import FavoritePbxIncomingCallCentralSwitchWidget from 'flow/components/central-switch/central-switch-widgets/FavoritePbxIncomingCallCentralSwitchWidget';
import FavoritePbxOngoingCallCentralSwitchWidget from 'flow/components/central-switch/central-switch-widgets/FavoritePbxOngoingCallCentralSwitchWidget';
import RetailerLogoCentralSwitchWidget from 'flow/components/central-switch/central-switch-widgets/RetailerLogoCentralSwitchWidget';
import CentralSwitchDialpadWrapper from 'flow/components/central-switch/central-switch-widgets/CentralSwitchDialpadWrapper';
import MissedCallsFromQueuesCentralSwitchWidget from 'flow/components/central-switch/central-switch-widgets/missed-queue-calls/MissedCallsFromQueuesCentralSwitchWidget';
import CentralSwitchWidgetCoListeningAlpha from 'flow/components/central-switch/central-switch-widgets/CentralSwitchWidgetCoListeningAlpha';
var CentralSwitchWidgetsBase = {
  dialPad: {
    component: CentralSwitchDialpadWrapper,
    translationKey: 'central_switch.dialpad.description'
  },
  favoriteContacts: {
    component: FavoriteContactsCentralSwitchWidget,
    translationKey: 'central_switch.favorite_contacts.description'
  },
  favoritePBXOngoingCalls: {
    component: FavoritePbxOngoingCallCentralSwitchWidget,
    translationKey: 'central_switch.favorite_pbx_ongoing_calls.title'
  },
  favoritePBXIncomingCalls: {
    component: FavoritePbxIncomingCallCentralSwitchWidget,
    translationKey: 'central_switch.favorite_pbx_incoming_calls.title'
  },
  favoritePBX: {
    component: FavoritePbxCentralSwitchWidget,
    translationKey: 'central_switch.favorite_pbx.description'
  },
  userCalendar: {
    component: UserCalendarCentralSwitchWidget,
    translationKey: 'contact.calendar'
  },
  RecentContacted: {
    component: RecentContactedCentralSwitchWidget,
    translationKey: 'central_switch.recently_contacted.description'
  },
  RetailerLogo: {
    component: RetailerLogoCentralSwitchWidget,
    translationKey: 'central_switch.logo'
  },
  missedCallsFromQueues: {
    component: MissedCallsFromQueuesCentralSwitchWidget,
    translationKey: 'central_switch.missed_calls_from_queues.description'
  }
};
var CoListeningAutoAlphaWidget = {
  coListeningAutoAlpha: {
    component: CentralSwitchWidgetCoListeningAlpha,
    translationKey: 'Auto co-listening'
  }
};
export var selectIsEligibleForCoListeningAutoAlpha = createSelector([selectOwnCustomerKey, selectOwnExtensionKey], function (ownCustomerKey, ownExtensionKey) {
  return ownCustomerKey === 'customer-178798' || ownCustomerKey === 'customer-210056' || ownCustomerKey === 'customer-269079' || ownExtensionKey === 'extension-4229674' || ownExtensionKey === 'extension-1379' || ownExtensionKey === 'extension-1829770';
});

/**
 * Central switch is the overview pane behind Contacts, which is where the slimmed-down Teams app
 * lands (see StartView) - so these widgets are the one remaining way into a section it hides.
 *
 * `favoritePBX` and `missedCallsFromQueues` navigate to `pbx.queues.entityKey`, dropping the user
 * inside the hidden section with no tab to come back from. The two call-list widgets do not
 * navigate, but they surface PBX services content on the landing page of an app whose whole point
 * is to be a call surface, so they go as well rather than leaving the rule half-applied.
 */
var PBX_WIDGET_KEYS = ['favoritePBX', 'favoritePBXOngoingCalls', 'favoritePBXIncomingCalls', 'missedCallsFromQueues'];
export var selectAvailableCentralSwitchWidgets = createSelector([selectIsEligibleForCoListeningAutoAlpha, getIsAppEmbedded], function (isEligibleForCoListeningAutoAlpha, embedded) {
  var widgets = isEligibleForCoListeningAutoAlpha ? _objectSpread(_objectSpread({}, CentralSwitchWidgetsBase), CoListeningAutoAlphaWidget) : _objectSpread({}, CentralSwitchWidgetsBase);

  // CentralSwitch re-filters its widget list whenever this changes, and the picker reads the
  // same map, so removing them here takes them out of both.
  if (isSlimmedTeamsApp(embedded)) {
    PBX_WIDGET_KEYS.forEach(function (key) {
      return delete widgets[key];
    });
  }
  return widgets;
});